import gql from 'graphql-tag'

export const QUERY_USERS_WITH_TEMP = gql`
  query UsersWithTemp($search: String!) {
    usersWithTemp(search: $search) {
      id
      documentNo
      name
      phone
      isTemp
    }
  }
`

export const QUERY_USER_CASHBACK_WALLET = gql`
  query userCashbackWallets($documentNo: String!, $startDate: String!, $endDate: String!) {
    userCashbackWallets(documentNo: $documentNo, startDate: $startDate, endDate: $endDate) {
      wallet {
        amount
        activatedAmount
        activatedDate
        consumedAmount
        blockedAmount
        expired
      }
      industryWallet {
        amount
        activatedAmount
        consumedAmount
        blockedAmount
        expired
      }
    }
  }
`

export const QUERY_USER_CASHBACK_HISTORY = gql`
  query UserCashbackHistory($documentNo: String!, $startDate: String!, $endDate: String!) {
    userCashbackHistory(documentNo: $documentNo, startDate: $startDate, endDate: $endDate) {
      count
      data {
        date
        couponId
        transactionType
        value
        adjustmentReason
      }
    }
  }
`

export const QUERY_USER_NEXT_BUY_CASHBACK_HISTORY = gql`
  query UserNextBuyCashbackHistory($documentNo: String!, $startDate: String!, $endDate: String!) {
    userNextBuyCashbackHistory(documentNo: $documentNo, startDate: $startDate, endDate: $endDate) {
      count
      data {
        date
        couponId
        transactionType
        value
        adjustmentReason
      }
    }
  }
`

export const QUERY_ZE_COMPENSA = gql`
  query GetIndustryBenefitsMovementHistory($input: InputGetIndustryBenefitsMovementHistory!) {
    getIndustryBenefitsMovementHistory(input: $input) {
      benefitsMovementHistory {
        benefit {
          value
          image
        }
        offersSchedule {
          name
          id
        }
        unit {
          name
        }
        user {
          name
          phone
          documentNo
        }
        activatedAt
        expiresAt
        consumedAt
        status
        couponId
      }
    }
  }
`

export const QUERY_USER_OFFERS = gql`
  query UserOffers($page: Int!, $pageSize: Int!, $sort: [String], $sortDirection: [SortDirection], $search: String, $input: UserOffersInput) {
    userOffers(page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection, search: $search, input: $input) {
      records
      page
      offerSchedules {
        _id
        active
        status
        name
        origin
        description
        start_date
        end_date
        created_at
        updated_at
        activatable
        has_results
        products_count
        types
        industry {
          name
          proposal_deadline
          is_mercapromo
        }
        segments {
          name
        }
        offer_sales {
          ... on OfferSale {
            sku
            name
            active
            ean
            eans
            price_1
            price_2
            price_base_industry
            rebate
            minimum_per_client
            maximum_per_client
            image_url
            user_sale_consumption_amount
            activated_at
            product {
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesGroup {
            _id
            name
            price_1
            price_2
            price_base_industry
            minimum_per_client
            maximum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            offer_sales {
              name
              sku
              active
              finalized
              ean
              eans
              image_url
              user_sale_consumption_amount
              activated_at
              product {
                image
                eans
                ean
              }
            }
          }
        }
        percentage_offer_sales {
          ... on OfferSalePercentage {
            name
            sku
            active
            ean
            eans
            percentage_discount
            maximum_per_client
            minimum_per_client
            image_url
            user_sale_consumption_amount
            activated_at
            product {
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesPercentageGroup {
            _id
            name
            percentage_discount
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            percentage_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              user_sale_consumption_amount
              activated_at
              product {
                image
                eans
                ean
              }
            }
          }
        }
        cashback_percentage_offer_sales {
          ... on OfferSaleCashbackPercentage {
            name
            sku
            active
            ean
            eans
            price_1
            cashback_percentage
            maximum_per_client
            minimum_per_client
            image_url
            user_sale_consumption_amount
            activated_at
            product {
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesCashbackPercentageGroup {
            _id
            name
            price_1
            cashback_percentage
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            cashback_percentage_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              user_sale_consumption_amount
              activated_at
              product {
                image
                eans
                ean
              }
            }
          }
        }
        cashback_absolute_offer_sales {
          ... on OfferSaleCashbackAbsolute {
            name
            sku
            active
            ean
            eans
            price
            cashback_absolute
            maximum_per_client
            minimum_per_client
            image_url
            user_sale_consumption_amount
            activated_at
            product {
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesCashbackAbsoluteGroup {
            _id
            name
            price
            cashback_absolute
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            cashback_absolute_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              user_sale_consumption_amount
              activated_at
              product {
                image
                eans
                ean
              }
            }
          }
        }
        points_offer_sales {
          ... on OfferSalePoints {
            name
            sku
            active
            ean
            eans
            price
            additional_points_rate
            maximum_per_client
            minimum_per_client
            image_url
            user_sale_consumption_amount
            activated_at
            product {
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesPointsGroup {
            _id
            name
            price
            additional_points_rate
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            points_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              user_sale_consumption_amount
              activated_at
              product {
                image
                eans
                ean
              }
            }
          }
        }
        takepay_offer_sales {
          ... on OfferSaleTakeAndPay {
            name
            sku
            active
            ean
            eans
            take
            pay
            maximum_per_client
            image_url
            user_sale_consumption_amount
            activated_at
            product {
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesTakeAndPayGroup {
            _id
            name
            take
            pay
            maximum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            takepay_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              user_sale_consumption_amount
              activated_at
              product {
                image
                eans
                ean
              }
            }
          }
        }
        combo_offer_sales {
          name
          image
          combo_id
          maximum_per_client
          active
          discount_by_count
          trigger_products {
            ... on TriggerProduct {
              quantity
              name
              sku
              ean
              eans
              user_sale_consumption_amount
              activated_at
              product {
                sku
                ean
                eans
                name
              }
            }
            ... on TriggerProductGroup {
              _id
              name
              quantity
              trigger_products {
                name
                sku
                ean
                eans
                user_sale_consumption_amount
                activated_at
                product {
                  _id
                  sku
                  ean
                  eans
                  name
                }
              }
            }
          }
          target_products {
            ... on TargetProduct {
              percentage_discount
              name
              sku
              ean
              eans
              user_sale_consumption_amount
              activated_at
              product {
                sku
                ean
                eans
                name
              }
            }
            ... on TargetProductGroup {
              _id
              name
              percentage_discount
              target_products {
                name
                sku
                ean
                eans
                user_sale_consumption_amount
                activated_at
              }
            }
          }
        }
        next_buy_cashback_offer_sales {
          ... on OfferSaleNextBuyCashback {
            sku
            ean
            eans
            name
            active
            image_url
            max_coupons
            minimum_per_client
            cashback_absolute_discount
            cashback_expiration_date
            price
            user_sale_consumption_amount
            activated_at
            product {
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSaleNextBuyCashbackGroup {
            _id
            name
            minimum_per_client
            cashback_absolute_discount
            cashback_expiration_date
            max_coupons
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            next_buy_cashback_offer_sales {
              sku
              ean
              eans
              name
              active
              image_url
              user_sale_consumption_amount
              activated_at
              product {
                sku
                ean
                eans
                name
              }
            }
          }
        }
        dynamic_rule_offer_sales {
          active
          trigger_products {
            active
            sku
            ean
            eans
            name
            equivalent_quantity
            group_id
            group_name
            group_rules_exhibition
            image_url
            user_sale_consumption_amount
          }
          target_rules {
            type
            mode
            topic
          }
          trigger_rules {
            maximum_per_client
            trigger_amount
            operator
            group_operator
            trigger_mode
          }
          benefits {
            type
            value
            minu_prize
            voucher_provider
          }
          vouchers
        }
        cross_sell_offer_sales {
          active
          trigger_products {
            active
            sku
            ean
            eans
            name
            equivalent_quantity
            group_id
            group_name
            group_rules_exhibition
            image_url
            user_sale_consumption_amount
            activated_at
          }
          trigger_rules {
            maximum_per_client
            trigger_amount
            operator
            group_operator
            trigger_mode
          }
          target_products {
            active
            sku
            ean
            eans
            name
            group_id
            group_name
            group_rules_exhibition
            image_url
            user_sale_consumption_amount
            activated_at
          }
          target_rules {
            type
            discount
          }
        }
      }
    }
  }
`

export const QUERY_USER = gql`
  query User($_id: ID) {
    user(_id: $_id) {
      _id
      name
      email
      phone
      is_confirmed
      confirmed_at
      confirmation_sent_at
    }
  }
`

export const QUERY_USER_ACTIVE_PRODUCT_VOUCHER = gql`
  query UserActiveProductVoucher($documentNo: String!) {
    userActiveProductVoucher(document_no: $documentNo) {
      userInfo {
        document_no
        name
        phone
        points
      }
      activeVoucher {
        _id
        product_description
        money
        activated_unit {
          id_erp
          name
        }
        activated_at
        expires_at
        image_url
      }
    }
  }
`

export const QUERY_USER_POINTS_HISTORY = gql`
  query UserPointsHistory($document_no: String!, $pageSize: Int!, $page: Int!, $initialDate: DateTime, $finalDate: DateTime, $units: [String!]) {
    userPointsHistory(document_no: $document_no, pageSize: $pageSize, page: $page, initialDate: $initialDate, finalDate: $finalDate, units: $units) {
      items {
        type
        unit {
          name
        }
        money
        points
        bonus_product
        date
        campaign
      }
      records
      page
    }
  }
`

export const MUTATION_VALIDATE_EXCHANGE_CODE = gql`
  mutation ValidateExchangeCode($document_no: String!, $code: String!, $unit: String!) {
    validateExchangeCode(document_no: $document_no, code: $code, unit: $unit) {
      success
      error {
        reason
        message
        attemptsCount
        blockedUntil
      }
    }
  }
`
